import React from 'react';

const Invoice2: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00008 7.66666C3.71142 7.66666 2.66675 8.71133 2.66675 9.99999V30C2.66675 31.2887 3.71142 32.3333 5.00008 32.3333H35.0001C36.2887 32.3333 37.3334 31.2887 37.3334 30V9.99999C37.3334 8.71133 36.2887 7.66666 35.0001 7.66666H5.00008ZM0.666748 9.99999C0.666748 7.60676 2.60685 5.66666 5.00008 5.66666H35.0001C37.3933 5.66666 39.3334 7.60676 39.3334 9.99999V30C39.3334 32.3932 37.3933 34.3333 35.0001 34.3333H5.00008C2.60685 34.3333 0.666748 32.3932 0.666748 30V9.99999Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.33325 12.3333C8.88554 12.3333 9.33325 12.7811 9.33325 13.3333V26.6667C9.33325 27.219 8.88554 27.6667 8.33325 27.6667C7.78097 27.6667 7.33325 27.219 7.33325 26.6667V13.3333C7.33325 12.7811 7.78097 12.3333 8.33325 12.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.6665 12.3333C32.2188 12.3333 32.6665 12.7811 32.6665 13.3333V26.6667C32.6665 27.219 32.2188 27.6667 31.6665 27.6667C31.1142 27.6667 30.6665 27.219 30.6665 26.6667V13.3333C30.6665 12.7811 31.1142 12.3333 31.6665 12.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1628 12.3333C14.7151 12.3333 15.1628 12.7811 15.1628 13.3333V21.6667C15.1628 22.219 14.7151 22.6667 14.1628 22.6667C13.6106 22.6667 13.1628 22.219 13.1628 21.6667V13.3333C13.1628 12.7811 13.6106 12.3333 14.1628 12.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 12.3333C20.5523 12.3333 21 12.7811 21 13.3333V26.6667C21 27.219 20.5523 27.6667 20 27.6667C19.4477 27.6667 19 27.219 19 26.6667V13.3333C19 12.7811 19.4477 12.3333 20 12.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.8333 12.3333C26.3855 12.3333 26.8333 12.7811 26.8333 13.3333V21.6667C26.8333 22.219 26.3855 22.6667 25.8333 22.6667C25.281 22.6667 24.8333 22.219 24.8333 21.6667V13.3333C24.8333 12.7811 25.281 12.3333 25.8333 12.3333Z"
      />
    </svg>
  );
};

export default Invoice2;
